import {
  CooksMealProps,
  GET_COOK_MEALS,
  SET_MEAL,
  GET_REVIEWS,
  SET_REVIEWS,
  CooksProfileActionTypes,
} from './types';

const initState: CooksMealProps = {
  meals: [],
  reviews: [],
};

export const cooksProfile = (
  state = initState,
  action: CooksProfileActionTypes
): CooksMealProps => {
  const { type, meals, reviews } = action;
  switch (type) {
    case GET_COOK_MEALS:
      return state;
    case SET_MEAL:
      return { ...state, meals: meals };
    case GET_REVIEWS:
      return state;
    case SET_REVIEWS:
      return { ...state, reviews: reviews };
    default:
      return state;
  }
};
